import { Typography } from "antd";
import { RuleFiles } from "components";
import { ItemInfoType, RateEntity } from "interfaces";
import { dateFormat, formatWithDecimals } from "utils";

export const getColumns = (rates: RateEntity) => {
  const { rates: ratesObj } = rates;
  const nowDate = dateFormat(new Date());

  return [
    {
      id: "info-currency-rate",
      width: 24,
      label: `Доступные на платформе ЦВ`,
      text: (
        <div>
          {Object.keys(ratesObj).map((rate) => (
            <Typography.Paragraph key={rate}>
              {rate} курс на {nowDate} - {formatWithDecimals(ratesObj[rate])} руб.
            </Typography.Paragraph>
          ))}
        </div>
      ),
    },
    {
      label: "Действующая редакция правил:",
      text: <RuleFiles id="info-rules-link" />,
    },
  ].filter((c) => !!c) as ItemInfoType[];
};
